import React from 'react';
import styles from './progress-bar.css';

export const ProgressBar = ({ start, end, value, limitStart, limitEnd }) => {
  return (
    <div className={styles.main}>
      <span className={styles.time}>{start}</span>
      <div className={styles.wrapper}>
        <span className={styles.bar}>
          {limitStart > 0 && (
            <span className={styles.limit} style={{ left: `${limitStart}%` }}></span>
          )}
          <span className={styles.filled} style={{ width: `${value}%` }}></span>
          <span className={styles.indicator} style={{ left: `${value}%` }}></span>
          {limitEnd > 0 && <span className={styles.limit} style={{ left: `${limitEnd}%` }}></span>}
        </span>
      </div>
      <span className={styles.time}>{end}</span>
    </div>
  );
};
